import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { AuthGuard, LoginGuard } from './acore/guards';


export const routes: Routes = [
      {
            path: '',
            redirectTo: 'login',
            pathMatch: 'full'

            // loadChildren: './pages/login/login.module#LoginModule',
            // canActivate: [LoginGuard]
      }, 
      {
            path: 'login',
            loadChildren: './pages/login/login.module#LoginModule',
            canActivate: [LoginGuard]
      }, 
      
      {
            path: 'pages',
            loadChildren: './pages/desktop/desktop.module#DesktopModule',
             canActivate: [AuthGuard],
             canActivateChild: [AuthGuard]
      },

      {
            path: 'pages/:id/:pass',
            loadChildren: './pages/desktop/desktop.module#DesktopModule',
            //  canActivate: [AuthGuard],
            //  canActivateChild: [AuthGuard]
      }
];

const extraOptions: ExtraOptions = {
      enableTracing: false,
      useHash: true,
      onSameUrlNavigation: 'ignore'
};


export const routing: ModuleWithProviders = RouterModule.forRoot(routes, extraOptions);

